import * as React from 'react';
import ClientSearch from '../../components/common/SearchText';
import MyClientLists from './MyClientList';
import Box from '@mui/material/Box';
import { Container, LinearProgress } from '@mui/material';
import { graphql } from '../../__generated__';
import { useQuery } from '@apollo/client';

export const myClientsSearchQuery = graphql(/* GraphQL */ `
  query SearchMyClientsUsers($searchText: String, $viewType: String) {
    users(searchText: $searchText, viewType: $viewType) {
      ...MyClientsSearchResult
    }
  }
`);

const MyClientsView = () => {
  const [viewType] = React.useState<string>('MODULE');
  const [text, setText] = React.useState<string>('');
  const onValueChange = (value: string) => {
    setText(value);
  };

  const { data, loading, refetch } = useQuery(myClientsSearchQuery, {
    variables: { searchText: text, viewType: viewType },
  });

  React.useEffect(() => {
    refetch({
      searchText: text,
      viewType: viewType,
    });
  }, [text, viewType, refetch]);

  return (
    <Container fixed>
      <Box m={1}>
        <ClientSearch
          placeholderText="Search..."
          value={text}
          onValueChange={onValueChange}
          onClear={() => setText('')}
        />
      </Box>

      {loading && (
        <Box m={1}>
          <LinearProgress />
        </Box>
      )}

      {data && <MyClientLists query={data} loading={loading} />}
    </Container>
  );
};

export default MyClientsView;
